import { Helmet } from 'react-helmet-async';

export function HeadTags() {
  return (
    <Helmet>
      {/* Preconnect to required origins */}
      <link rel="preconnect" href="https://api.github.com" />
      <link rel="preconnect" href="https://avatars.githubusercontent.com" />
      <link rel="dns-prefetch" href="https://api.github.com" />
      <link rel="dns-prefetch" href="https://avatars.githubusercontent.com" />
      
      {/* Preload critical assets */}
      <link 
        rel="preload" 
        href="/fonts/inter-var.woff2" 
        as="font" 
        type="font/woff2" 
        crossOrigin="anonymous" 
      />
    </Helmet>
  );
}
